'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _nodeForge = require('node-forge');

var _rsa = require('../keys/rsa');

var _publicKey = require('./publicKey');

var _publicKey2 = _interopRequireDefault(_publicKey);

var _constants = require('./constants');

var _encoding = require('../utils/encoding');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EncryptionPrivateKey = function EncryptionPrivateKey(_ref) {
  var algo = _ref.algo,
      pemPrivateKey = _ref.pemPrivateKey,
      password = _ref.password,
      _ref$generate = _ref.generate,
      generate = _ref$generate === undefined ? true : _ref$generate;

  _classCallCheck(this, EncryptionPrivateKey);

  _initialiseProps.call(this);

  if (pemPrivateKey) {
    this.load(pemPrivateKey, password);
  } else if (generate) {
    this.generate(algo);
  }
}

// decrypt should be used for message encrypted with pke.EncryptionPublicKey.encrypt()


// decrypt should be used for message encrypted with pke.EncryptionPublicKey.encryptShort()
;

EncryptionPrivateKey.generateAsync = async function (algo) {
  var privateKey = new EncryptionPrivateKey({ generate: false });
  privateKey._algo = algo;
  switch (algo) {
    case _constants.PKE_ALGO_RSA.name:
      {
        privateKey._key = await _rsa.RSAPrivateKey.generateAsync();
        return privateKey;
      }
    default:
      throw new Error('Unsupported encryption algorithm "' + algo + '"');
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this = this;

  this.generate = function (algo) {
    _this._algo = algo;
    switch (algo) {
      case _constants.PKE_ALGO_RSA.name:
        {
          _this._key = new _rsa.RSAPrivateKey();
          break;
        }
      default:
        throw new Error('Unsupported encryption algorithm "' + algo + '"');
    }
  };

  this.load = function (pemPrivateKey) {
    var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var _decodePrivateKey = (0, _encoding.decodePrivateKey)(pemPrivateKey, password),
        key = _decodePrivateKey.key,
        oid = _decodePrivateKey.oid;

    switch (oid) {
      case _constants.PKE_ALGO_RSA.oid:
        _this._key = new _rsa.RSAPrivateKey(_nodeForge.pki.privateKeyFromAsn1(key));
        _this._algo = _constants.PKE_ALGO_RSA.name;
        break;
      default:
        throw new Error('Unsupported encryption algorithm OID ' + oid + '"');
    }
  };

  this.publicKey = function () {
    switch (_this._algo) {
      case _constants.PKE_ALGO_RSA.name:
        return new _publicKey2.default({
          publicKey: _this._key.publicKey(),
          algo: _this._algo
        });
      default:
        throw new Error('Unsupported encryption algorithm "' + _this._algo + '"');
    }
  };

  this.decrypt = function (ciphertext) {
    return _this._key.decrypt(ciphertext);
  };

  this.decryptShort = function (ciphertext) {
    return _this._key.decryptShort(ciphertext);
  };

  this.export = function () {
    var password = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    var privateKeyInfo = void 0;
    switch (_this._algo) {
      case _constants.PKE_ALGO_RSA.name:
        privateKeyInfo = _this._key.toPkcs8();
        break;
      default:
        throw new Error('Unsupported encryption algorithm "' + _this._algo + '"');
    }

    if (!password) return (0, _encoding.encodePrivateKeyInfo)(privateKeyInfo, _this._algo);

    var encryptedPrivateKeyInfo = _nodeForge.pki.encryptPrivateKeyInfo(privateKeyInfo, password, { algorithm: 'aes256' });

    // Export keys to pem format
    return _nodeForge.pki.encryptedPrivateKeyToPem(encryptedPrivateKeyInfo);
  };
};

exports.default = EncryptionPrivateKey;